<template>
	<div class="now">
		<span class="nowYear">{{ getYear }}</span>
		<span class="nowDate">{{ getCurrentDate }}</span>
	</div>
</template>

<script>
import moment from "moment/moment";

export default {
	name: "DateNow",
	computed: {
		getYear() {
			return moment().year();
		},
		getCurrentDate() {
			const [ dayOfWeek, monthAndDay ] = moment().format('llll').split(',');
			return `${ dayOfWeek }, ${ monthAndDay }`;
		}
	},
};
</script>

<style scoped lang="scss">
@import "DateNow";
</style>
